// extracted by mini-css-extract-plugin
module.exports = {"paymentMethod":"PaymentMethod_paymentMethod__3tCie","aRow":"PaymentMethod_aRow__2Yt6k","payment":"PaymentMethod_payment__1JdE5","orSeparator":"PaymentMethod_orSeparator__1z1dO"};